import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Input from "../../../../component/common/Input";
import httpServices from "../../../../services/httpServices";
import { useParams } from "react-router-dom";
import { FaCross } from "react-icons/fa6";
import Button from "../../../../component/common/Button";
import { toast } from "react-toastify";

// Validation schema using Yup
const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  mobileNumber: yup
    .string()
    .matches(/^[0-9]+$/, "Mobile number must be numeric")
    .required("Mobile number is required"),
  password: yup
    .string()
    .min(8, "Password must be at least 8 characters")
    .required("Password is required"),
});

const AddTicketScanner = ({
  editData,
  toggleAddMoreScanner,
  getEventScanner,
}) => {
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: editData,
  });

  const onSubmit = async (data) => {
    if (editData) {
      hanldleUpdateScanner(editData.id, data);
    } else {
      createScanner(data);
    }
  };

  const createScanner = async (data) => {
    const toastId = toast.loading("Adding scanner...");
    try {
      const { response, error } = await httpServices.post(
        `/scannersDetails/create`,
        {
          ...data,
          eventId: id,
        }
      );
      if (error) {
        throw error;
      }
      if (response.status === 201) {
        toggleAddMoreScanner();
        getEventScanner();
        toast.update(toastId, {
          render: "Scanner added successfully",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });
      }
    } catch (error) {
      toast.update(toastId, {
        render: "Error adding scanner",
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    }
  };

  const hanldleUpdateScanner = async (id, data) => {
    try {
      const { response, error } = await httpServices.put(
        `/scannersDetails/update/${id}`,
        data
      );

      if (error) {
        throw error;
      }
      if (response.status === 200) {
        toast.success("Scanner updated successfully");
        toggleAddMoreScanner();
        getEventScanner();
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[999]"
      onClick={toggleAddMoreScanner}
    >
      <div
        className="bg-white shadow-md rounded-lg w-full max-w-md p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-semibold text-blue-600 mb-6">
          Add Ticket Scanner
        </h2>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          {/* Name Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Name
            </label>
            <Input type="text" {...register("name")} placeholder="Enter name" />
            {errors.name && (
              <p className="text-red-500 text-sm">{errors.name.message}</p>
            )}
          </div>

          {/* Email Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Email
            </label>
            <Input
              type="email"
              {...register("email")}
              placeholder="Enter email"
            />
            {errors.email && (
              <p className="text-red-500 text-sm">{errors.email.message}</p>
            )}
          </div>

          {/* Mobile Number Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Mobile Number
            </label>
            <Input
              type="text"
              {...register("mobileNumber")}
              placeholder="Enter mobile number"
            />
            {errors.mobileNumber && (
              <p className="text-red-500 text-sm">
                {errors.mobileNumber.message}
              </p>
            )}
          </div>

          {/* Password Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Password
            </label>
            <Input
              type="password"
              {...register("password")}
              placeholder="Enter password"
            />
            {errors.password && (
              <p className="text-red-500 text-sm">{errors.password.message}</p>
            )}
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition duration-200"
          >
            Add
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddTicketScanner;
